import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSiteConfig } from "../../context/SiteConfigContext";
import { useCart } from "../../context/CartContext";

import {
  Swiper,
  SwiperSlide,
  Autoplay,
  Pagination,
} from "../homepage/Shared/CustomSwiper";
import { Heart, ShoppingBag } from "lucide-react";
import { showError } from "../../utils/toastUtils";
import Auth from "../../utils/AuthUtils";
import wishlistAPI from "../../api/wishlistApi";

function Card({ item }) {
  const { addToCart } = useCart();
  const navigate = useNavigate();

  const { config } = useSiteConfig();

  const initialPrice =
    item?.productType === "Variant"
      ? (item?.variants?.[0]?.price ?? 0)
      : (item?.price ?? 0);

  const initialMrp =
    item?.productType === "Variant"
      ? (item?.variants?.[0]?.mrp ?? 0)
      : (item?.mrp ?? 0);

  const initialDiscount =
    item?.productType === "Variant"
      ? (item?.variants?.[0]?.discount ?? 0)
      : (item?.discount ?? 0);

  const initialStock =
    item?.productType === "Variant"
      ? (item?.variants?.[0]?.stock ?? 0)
      : (item?.stock ?? 0);

  const [image, setImage] = useState(item?.thumbnail);
  const [slug, setSlug] = useState(item?.slug);
  const [title, setTitle] = useState(item?.title);

  const [activePrice, setActivePrice] = useState(initialPrice);
  const [activeMrp, setActiveMrp] = useState(initialMrp);
  const [activeDiscount, setActiveDiscount] = useState(initialDiscount);
  const [activeStock, setActiveStock] = useState(initialStock);
  const [activeVariantId, setActiveVariantId] = useState(
    item?.productType === "Variant" && item?.variants?.length
      ? item?.variants[0]._id
      : null,
  );
  const [isWishlisted, setIsWishlisted] = useState(item.isWishlisted || false);

  const galleryImages = [item?.thumbnail, ...(item?.gallery || [])].filter(
    Boolean,
  );

  // Update price & image when variant changes
  useEffect(() => {
    if (item?.productType !== "Variant") return;
    const selected = item?.variants?.find((v) => v._id === activeVariantId);
    if (selected) {
      const newImg = selected.images?.[0] || item?.thumbnail;
      setImage(newImg);
      setActivePrice(selected.price);
      setActiveMrp(selected.mrp);
      setActiveDiscount(selected.discount);
      setActiveStock(selected.stock);
    }
  }, [activeVariantId, item]);

  const hasDiscount =
    activeDiscount !== null && activeDiscount > 0 && activeMrp > activePrice;

  const handleAddToCart = (e) => {
    const action = e.currentTarget.getAttribute("data-action");

    try {
      addToCart(item?._id, 1, activeVariantId || "");

      if (action === "buy-now") {
        navigate("/checkout");
      }
    } catch (err) {
      console.error("Add to cart error:", err);
    }
  };

  const handleWishlistToggle = async (e) => {
    e.preventDefault();

    const isLoggedIn = Auth.getToken();

    if (!isLoggedIn) {
      showError("Please log in to manage your wishlist");
      return;
    }

    try {
      const res = await wishlistAPI.addProduct({ productId: item?._id });
      if (res.code === 200) {
        setIsWishlisted((prev) => !prev);
      }
    } catch (error) {
      showError("Failed to update wishlist");
    }
  };

  const isOutOfStock = activeStock <= 0;

  return (
    <div
      className="custom-product-card-root text-decoration-none"
    >
      <div className="custom-product-card-visual-wrap">
        {/* Top Actions */}
        <div className="custom-product-card-top-actions">
          <button
            className="custom-product-card-icon-btn"
            type="button"
            className={`wishlist-btn ${isWishlisted ? "active" : ""}`}
            onClick={handleWishlistToggle}
            aria-label="Add to wishlist"
          >
            <Heart size={16}   strokeWidth={isWishlisted ? 0 : 1.5}
            className="heart-icon" />
          </button>
         
        </div>

        {/* Product Image */}
        <Link  to={`/shop/${slug}`} className="custom-product-card-img-container">
          <img
            src={item?.thumbnail}
            alt={title}
            loading="lazy"
            className="custom-product-card-img"
          />
        </Link>

        {/* Hover Slide-up Button */}
         {isOutOfStock && (
          <p className="text-danger fw-bold mt-1">Out of Stock</p>
        )}
        <button className="custom-product-card-add-btn"  data-id={item?._id}
              data-price={activePrice}
              data-variant={activeVariantId || ""}
              data-quantity={1}
              data-action="cart"
              data-bs-toggle="offcanvas"
              data-bs-target="#shoppingCartCanvas"
              onClick={handleAddToCart}>
          <ShoppingBag size={16} /> QUICK ADD
        </button>
      </div>

      <div className="custom-product-card-info text-center">
        <span className="custom-product-card-cat">{item?.category}</span>
        <Link to={`/shop/${slug}`} className="custom-product-card-title text-decoration-none">{title}</Link>
           <div className="d-flex justify-content-center">
            <p className="custom-product-card-price mb-0">₹{activePrice}</p>
            <p className="product-price-delete ms-2 mb-0">₹{activeMrp}</p>
          </div>
      </div>
    </div>
  );
}

export default Card;
